<template>
    <tr>
        <td>
            <div class="color_select" :style="style" @click.stop="action_ShowPalette">
            </div>
        </td>
        <td>
            <input type="text" class="input_s w_full" :placeholder="$t('work_schedule.popup_work_code_settings.label_code')" v-model="code.title">
        </td>
        <td v-if="isDefault" style="text-align: center;">
            <span>{{ $t('work_schedule.popup_work_code_settings.label_no_work') }}</span>
        </td>
        <td v-if="!isDefault">
            <TimePicker
                v-model="code.startedAt"
            />
            <span style="padding: 0 5px;">~</span>
            <TimePicker
                v-model="code.endedAt"
            />
        </td>
        <td>
            <div class="btn_group">
                <button class="btn btn_xs btn_lgray_line" @click="action_MoveToTop" :disabled="isTop"><v-icon>mdi-chevron-double-up</v-icon></button>
                <button class="btn btn_xs btn_lgray_line" @click="action_MoveToUp" :disabled="isTop"><v-icon>mdi-chevron-up</v-icon></button>
                <button class="btn btn_xs btn_lgray_line" @click="action_MoveToDown" :disabled="isBottom"><v-icon>mdi-chevron-down</v-icon></button>
                <button class="btn btn_xs btn_lgray_line" @click="action_MoveToBottom" :disabled="isBottom"><v-icon>mdi-chevron-double-down</v-icon></button>
            </div>
        </td>
        <td class="txt_center">
            <button class="btn btn_s btn_dgray" @click="action_Remove">－ {{ $t('common.delete') }}</button>
        </td>
    </tr>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import TimePicker from '@/v2/views/Main/ShareComponents/Common/TimePickerHM.vue'
// import Palette from './ColorPalette.vue'
import { sheetState } from '../../../../../sheet-state'

export default {
    components: { TimePicker },
    props: {
        value: Object,
        index: Number,
        isTop: Boolean,
        isBottom: Boolean
    },
    data() {
        return {
            sheetState,

            code: {},
            startedAtString: '',
            endedAtString: '',
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if (newValue == undefined) { return }
                this.code = deepCopy(newValue)
            }
        },
        'code.title': {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.updateValue()
            }
        },
        'code.startedAt': {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.updateValue()
            }
        },
        'code.endedAt': {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.updateValue()
            }
        }
    },
    computed: {
        isDefault: function() { return this.value.isDefault },
        reservationSetting: function() { return this.sheetState.reservationSetting },
        palette: function() { return this.reservationSetting.workCodeColorPaletteID?.basicPalette },
        selectedHexString: function() {
            if (this.code.usingCustomColor == true) { return this.code.customColorCode }
            let index = this.code.paletteIndex ?? 0
            return this.palette[index]
        },
        style: function() { return 'background-color: ' + this.selectedHexString + ';' }
    },
    methods: {
        action_ShowPalette() {
            this.$emit('showColorPalette', this.code, this.index, this.$el)
            this.isShowPalette = true
        },
        action_ClosePalette() {
            this.isShowPalette = false
        },
        action_MoveToTop() {
            this.$emit('moveToTop', this.code, this.index)
        },
        action_MoveToUp() {
            this.$emit('moveToUp', this.code, this.index)
        },
        action_MoveToDown() {
            this.$emit('moveToDown', this.code, this.index)
        },
        action_MoveToBottom() {
            this.$emit('moveToBottom', this.code, this.index)
        },
        action_Remove() {
            this.$emit('removeValue', this.code, this.index)
        },


        // MARK: - Emit
        updateColor(hexString, index, customColor) {
            if (customColor == undefined) { /**/ }
            console.log(hexString)
            this.code.paletteIndex = index
        },


        // MARK: - Private
        updateValue() {
            this.$emit('updateValue', this.code, this.index)
        },
        
    }
}
</script>